import React from 'react';

import T from '../../../i18n/i18n';
import { Button } from '../../../../styles/globalComponents';
import { Container } from './TurnOrderConfig.styles';

export default ({className, onClickBack, onClickOrderAsc, onClickOrderDesc, onClickClear}) => {

    const handleBack = () => {
        if (typeof onClickBack === 'function') {
            onClickBack();
        }
    }

    const handleOrderAsc = () => {
        if (typeof onClickOrderAsc === 'function') {
            onClickOrderAsc();
        }
    }

    const handleOrderDesc = () => {
        if (typeof onClickOrderDesc === 'function') {
            onClickOrderDesc();
        }
    }

    const handleClear = () => {
        if (typeof onClickClear === 'function') {
            onClickClear();
        }
    }

    return <Container className={"scrollbar " + (className ? className : '')}>
        <Button color="#0f9" onClick={handleOrderAsc}><T value="turnorder.orderasc" /></Button>
        <Button color="#09f" onClick={handleOrderDesc}><T value="turnorder.orderdesc" /></Button>
        {/*<T value="turnorder.enableappend" />*/}
        <div style={{height: '50px', minHeight: '50px'}}> </div>
        <Button color="#fc3" onClick={handleClear}><T value="turnorder.clear" /></Button>
        <Button color="#f33" onClick={handleBack}><T value="turnorder.back" /></Button>
    </Container>
}